<template>
  <div class="col-md-11 router-view-background">
    <h2 class="section-title mt-0">Dados da conta</h2>
    <div v-if="user && user.attributes">
      <div class="perfil-row">
        <span class="perfil-label">Nome</span>
        <span>{{ user.attributes.name || "—" }}</span>
      </div>
      <div class="perfil-row" v-if="user.attributes.username">
        <span class="perfil-label">Usuário</span>
        <span>{{ user.attributes.username }}</span>
      </div>
      <div class="perfil-row" v-if="user.attributes.email">
        <span class="perfil-label">E-mail</span>
        <span>{{ user.attributes.email }}</span>
      </div>
      <div class="perfil-row">
        <span class="perfil-label">Tipo</span>
        <span>{{ user.attributes.kind === 'admin' ? 'Administrador' : (user.attributes.kind || '—') }}</span>
      </div>

      <h3 class="section-title mt-5">Perfis de acesso</h3>
      <div v-if="user.roles && user.roles.length">
        <span v-for="(role, i) in user.roles" :key="i" class="perfil-chip">
          {{ role.name }}<template v-if="role.partner"> · {{ role.partner }}</template>
        </span>
      </div>
      <p v-else>Nenhum perfil vinculado.</p>
    </div>
    <p v-else>Não foi possível carregar os dados do usuário.</p>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Profile",
  computed: {
    ...mapState("login", ["user"])
  }
};
</script>

<style scoped>
.perfil-row {
  display: flex;
  padding: 12px 0;
  border-bottom: 1px solid var(--light-grey);
}
.perfil-label {
  width: 160px;
  font-weight: bold;
  color: var(--medium-blue);
}
.perfil-chip {
  display: inline-block;
  background: var(--jersey-yellow);
  color: white;
  border-radius: 4px;
  padding: 6px 12px;
  margin: 0 8px 8px 0;
  font-size: 0.85rem;
}
</style>
